import axios from 'axios';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { ConfigContext } from '../../Context/ConfigContext';
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';
import { confirmDialog } from 'primereact/confirmdialog';
import { Skeleton } from 'primereact/skeleton';
import { Checkbox } from "primereact/checkbox";
const Category = () => {
    const { apiUrl, apiHeadersJson, store_id } = useContext(ConfigContext);
    const [CategoryName, setCategoryName] = useState('');
    const [category_seq_no, setcategory_seq_no] = useState(1);
    const [category_is_show, setcategory_is_show] = useState(1);
    const [CategoryId, setCategoryId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [dataTableLoading, setDataTableLoading] = useState(true);
    const [keyword, setKeyword] = useState('');
    const [rows, setRows] = useState([]);
    const headers = apiHeadersJson;
    const toast = useRef(null);


    const HandleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const body = {
            category_name: CategoryName,
            category_id: CategoryId,
            store_id: store_id,
            category_is_show: category_is_show,
            category_seq_no: category_seq_no,
        };

        try {
            const response = await axios.post(`${apiUrl}/Masters/CreateCategory`, body, { headers });
            setLoading(false);
            const { success, message } = response.data;

            if (success) {
                handleResetForm();
                toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 3000 });
                GetList();
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
            setLoading(false);
        }
    };

    const GetList = async () => {
        setDataTableLoading(true);
        try {
            const response = await axios.get(`${apiUrl}/Masters/GetCategoryList`, { params: { keyword, store_id: store_id }, headers });
            const { success, data, message } = response.data;

            if (success) {
                setRows(data);
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
        } finally {
            setDataTableLoading(false);
        }
    };

    const handleResetForm = () => {
        setCategoryId(null);
        setCategoryName('');
        setcategory_is_show(1);
        setcategory_seq_no(1);
    };

    const confirmDelete = (id) => {
        confirmDialog({
            message: 'Are you sure you want to delete this category?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => DeleteCategory(id),
            reject: () => {
                toast.current.show({ severity: 'info', summary: 'Cancelled', detail: 'Delete operation cancelled', life: 3000 });
            }
        });
    };

    const DeleteCategory = async (id) => {
        try {
            const response = await axios.delete(`${apiUrl}/Masters/DeleteCategory`, { params: { category_id: id }, headers });
            const { success, message } = response.data;
            if (success) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 3000 });
                GetList();
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
        }
    };

    const GetInfo = async (id) => {
        try {
            const response = await axios.get(`${apiUrl}/Masters/GetCategoryInfo`, { params: { category_id: id }, headers })
            const { success, data, message } = response.data;
            if (success) {
                setCategoryId(data[0].category_id);
                setCategoryName(data[0].category_name);
                setcategory_seq_no(data[0].category_seq_no);
                setcategory_is_show(data[0].category_is_show);
            } else {
                toast.current.show({ severity: 'error', summary: 'error', detail: message, life: 3000, });
            }
        } catch (error) {
            console.log('error', error);
        }
    }

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            if (keyword) {
                GetList();
            }
        }, 500);
        return () => clearTimeout(delayDebounce);
    }, [keyword]);

    useEffect(() => {
        GetList();
    }, [store_id]);

    useEffect(() => {
        store_id && handleResetForm();
    }, [store_id]);

    const ActionBody = (data) => {
        return (
            <>
                <Button icon="pi pi-pencil" outlined onClick={() => GetInfo(data.category_id)} />
                <Button outlined className='ms-3' icon="pi pi-trash" severity="danger" onClick={() => confirmDelete(data.category_id)} />
            </>
        );
    };

    return (
        <>
            <div className="container-fluid">
                <Toast ref={toast} />
                <div className="d-flex justify-content-between align-items-center mt-4">
                    <div className="main-heading">
                        <h6>Category</h6>
                    </div>
                    <div className="main-heading-right">
                        <h6>Masters/Category</h6>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-4 mt-4">
                        <div className="card">
                            <h4 className="bg-dark text-white rounded-top p-3">Category</h4>
                            <form className='p-3' onSubmit={HandleSubmit}>
                                <div className="row">
                                    <div className="my-2">
                                        <label className="form-label">Category Name</label>
                                        <input
                                            type="text"
                                            value={CategoryName}
                                            className="form-control"
                                            onChange={(e) => setCategoryName(e.target.value)}
                                            required={true}
                                            placeholder='Enter Category Name'
                                        />
                                    </div>
                                    <div className="my-2">
                                        <label className="form-label">Category Seq No.</label>
                                        <input
                                            type="number"
                                            value={category_seq_no}
                                            className="form-control"
                                            onChange={(e) => setcategory_seq_no(e.target.value)}
                                            required={true}
                                            placeholder='Enter Category Seq'
                                        />
                                    </div>
                                    <div className="my-2">
                                        <label className="form-label">Show Category</label><br />

                                        <div className='d-flex justify-content-start align-itmes-center'>
                                            <label className="form-label">
                                                <span className='me-2'>Yes</span>
                                                <Checkbox onChange={e => setcategory_is_show(1)} checked={category_is_show === 1}></Checkbox>
                                            </label>
                                            <label className="form-label ms-3">
                                                <span className='me-2'>No</span>
                                                <Checkbox onChange={e => setcategory_is_show(0)} checked={category_is_show === 0}></Checkbox>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                {!CategoryId && <Button
                                    type="submit"
                                    label={loading ? "Loading..." : "Submit"}
                                    className="btn btn-success mt-3"
                                    disabled={loading || !CategoryName}
                                />}
                                {CategoryId &&
                                    <div>
                                        <Button
                                            type="submit"
                                            label={loading ? "Loading..." : "Update"}
                                            className="btn btn-success mt-3"
                                            disabled={loading || !CategoryName}
                                        />
                                        <Button
                                            type="button"
                                            onClick={handleResetForm}
                                            label={loading ? "Loading..." : "Reset"}
                                            className="btn btn-light mt-3 float-end"
                                            disabled={loading}
                                        />
                                    </div>
                                }
                            </form>
                        </div>
                    </div>
                    <div className="col-md-8 mt-4">
                        <div className="card">
                            <div className="rounded-top px-3 py-2 bg-dark d-flex justify-content-between align-items-center">
                                <h4 className="text-white">Category List</h4>
                                <IconField iconPosition="left" style={{ width: '35%' }}>
                                    <InputIcon className="pi pi-search"> </InputIcon>
                                    <InputText
                                        className='w-100'
                                        placeholder='Search By Category Name...'
                                        onChange={(e) => setKeyword(e.target.value)}
                                    />
                                </IconField>
                            </div>
                            {dataTableLoading ? (
                                [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(() => (
                                    <Skeleton shape='rectangle' width="100%" height="40px" className="mb-1" />
                                ))
                            ) : (
                                <DataTable value={rows} paginator rows={10} rowsPerPageOptions={[10, 20, 30]}>
                                    <Column field='store_name' header='Store Name' sortable />
                                    <Column field='category_id' header='ID' sortable style={{ width: '10%' }} />
                                    <Column field='category_name' header='Category Name' sortable />
                                    <Column field='category_seq_no' header='Category Seq' sortable />
                                    <Column field='category_is_show' header='Category Show' body={(data) => data.category_is_show === 1 ? 'Yes' : 'No'} sortable />
                                    <Column body={ActionBody} header='Action' />
                                </DataTable>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Category;
